module.exports = __webpack_public_path__ + "img/cadre-sante-f.8fe54b92.jpg";